import React, { Component } from "react";
import Select from 'react-select';

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// import Component
import {
  Card,
  Col,
  Row,
  CardBody,
  Label,
  Button,
  Form,
  Input,
  Container
} from "reactstrap";

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

import "./index.scss";
import axios from "axios";
import * as url from "../../helpers/url_helper";

const {REACT_APP_BACK_URL} = process.env;
const {REACT_APP_FRONT_URL} = process.env;

// Table data
let files = [];

export default class index extends Component {
  state = {
    categories: []
  }
  constructor(props) {
    super(props);
    const userRoles = this.getAuthUser().roles;
    if (userRoles.length > 0) {
      if (!userRoles.some(role => role.rolCode === 'MAL_VISU')) {
        window.location = '/logout';
      }
    }
    this.handleSearchFile = this.handleSearchFile.bind(this);
    this.getAllFiles();
    this.getAllCategories();
    this.state = {
      page: 1,
      sizePerPage: 10,
      fileData: files,
      columns: [
        {
          dataField: "recordId",
          text: "Record Id",
          sort: true,
        },
        {
          dataField: "name",
          text: "Nom",
          sort: true,
        },
        {
          dataField: "sizeFormatted",
          text: "Taille",
          sort: true,
        },
        {
          dataField: "exercice",
          text: "Exercice",
          sort: true,
        },
        {
          dataField: "category",
          text: "Catégorie",
          sort: true,
        },
        {
          dataField: "origine",
          text: "Origine",
          sort: true,
        },
        {
          dataField: "view",
          text: "Afficher",
          sort: false,
          formatter: this.linkShow,
        }
      ]
    };
  }

  getAuthUser = () => {
    if (localStorage.getItem("authUser")) {
      return JSON.parse(localStorage.getItem("authUser"));
    }
  }

  getAllCategories = () => {
    return axios.get(REACT_APP_BACK_URL + url.GET_ALL_CATEGORIES)
      .then((response) => {
          const categories = response.data;
          this.setState ({categories});
      });
  };

  handleSearchFile = (e) => {
    e.preventDefault();
    const data = {
      recordId: e.target.recordId.value,
      datehCreation: e.target.dateCreation.value,
      exercice: e.target.exercice.value,
      category: e.target.category.value
    };
    axios.post(REACT_APP_BACK_URL + url.POST_FILE_SEARCH, data).then((response) => {
      this.setState ({
        page: 1,
        sizePerPage: 10,
        fileData: response.data
      })
    });
  };

  getAllFiles = () => {
    return axios.get(REACT_APP_BACK_URL + url.GET_ALL_FILES)
      .then((response) => {
          files = response.data;
          this.setState ({
            page: 1,
            sizePerPage: 10,
            fileData: files,
          })
      });
  };

  linkShow = (cell, row) => {
    let link = REACT_APP_FRONT_URL + "/file/" + row.recordId + "?token=eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJORUEiLCJyb2xlcyI6IlBVVCxHRVQiLCJpYXQiOjE3MjY4NDY0MjcsImV4cCI6MjA1Mzg5NzIwMH0.sykHGtHZQAQWdcSZ0KD0mA1XH0lFsr7fay8R81-kDPP5TwbGN65bN92augmtaliFnuoZDtNXLkHNzg_68UVQgw";
    return (
      <a href={link} target="_blank" rel="noopener noreferrer">
        <i className="bx bx-show" style={{ fontSize: "25px", color: "#00a6e2" }}/>
      </a>
    );
  };

  render() {
    const defaultSorted = [
      {
        dataField: "recordId",
        order: "asc",
      },
    ];

    const pageOptions = {
      sizePerPage: 10,
      totalSize: files.length,
      custom: true,
    };

    const { SearchBar } = Search;
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="File Handler Viewer" breadcrumbItem="Module de centralisation des justificatifs transmis au CGOS" />
            <div className="d-xl-flex">
              <div className="w-100">
                <div className="d-md-flex">
                  <div className="w-100">
                    <Card>
                      <CardBody>
                      <div>
                        <Form onSubmit={this.handleSearchFile}>
                          <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <Row>
                                  <div className="col-md-2 mb-2"></div>
                                    <div className="col-md-2 mb-2">
                                      <Label
                                        htmlFor="horizontal-record-id-Input"
                                        className="col-form-label"
                                      >
                                        Record Id
                                      </Label>
                                      <Col>
                                        <Input
                                          type="number"
                                          className="form-control"
                                          id="horizontal-record-id-Input"
                                          name="recordId"
                                          placeholder=""
                                        />
                                      </Col>
                                    </div>
                                    <div className="col-md-2 mb-2">
                                      <Label
                                        htmlFor="horizontal-date-creation-Input"
                                        className="col-form-label"
                                      >
                                        Date création
                                      </Label>
                                      <Col>
                                        <Input
                                          type="date"
                                          className="form-control"
                                          id="horizontal-date-creation-Input"
                                          name="dateCreation"
                                          placeholder=""
                                        />
                                      </Col>
                                    </div>
                                    <div className="col-md-2 mb-2">
                                      <Label
                                        htmlFor="horizontal-exercice-Input"
                                        className="col-form-label"
                                      >
                                        Exercice
                                      </Label>
                                      <Col>
                                        <Input
                                          type="number"
                                          className="form-control"
                                          id="horizontal-exercice-Input"
                                          name="exercice"
                                          placeholder=""
                                        />
                                      </Col>
                                    </div>
                                    <div className="col-md-3 mb-2">
                                      <label className="col-form-label">Catégorie</label>
                                      <Select
                                        options={this.state.categories}
                                        name="category"
                                      />
                                    </div>
                                  </Row>
                                  <Row>
                                    <center>
                                      <Col lg={12}>
                                        <div className="mt-3">
                                          <Button
                                            type="submit"
                                            color="primary"
                                            className="w-md"
                                          >
                                            Rechercher
                                          </Button>
                                        </div>
                                      </Col>
                                    </center>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </Form>
                      </div>
                      <div className="container-fluid">
                        <Row>
                          <Col className="col-12">
                            <Card>
                              <CardBody>
                                <PaginationProvider
                                  pagination={paginationFactory(pageOptions)}
                                  keyField="recordId"
                                  columns={this.state.columns}
                                  data={this.state.fileData}
                                >
                                  {({ paginationProps, paginationTableProps }) => (
                                    <ToolkitProvider
                                      keyField="recordId"
                                      columns={this.state.columns}
                                      data={this.state.fileData}
                                      search
                                    >
                                      {toolkitProps => (
                                        <React.Fragment>
                                          <Row className="mb-2">
                                            <Col md="4">
                                              <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                  <SearchBar
                                                    {...toolkitProps.searchProps}
                                                  />
                                                  <i className="bx bx-search-alt search-icon" />
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>

                                          <Row>
                                            <Col xl="12">
                                              <div className="table-responsive">
                                                <BootstrapTable
                                                  keyField={"id"}
                                                  responsive
                                                  bordered={true}
                                                  striped={true}
                                                  defaultSorted={defaultSorted}
                                                  classes={
                                                    "table align-middle table-nowrap"
                                                  }
                                                  headerWrapperClasses={"thead-light"}
                                                  {...toolkitProps.baseProps}
                                                  {...paginationTableProps}
                                                />
                                              </div>
                                            </Col>
                                          </Row>

                                          <Row className="align-items-md-center mt-30">
                                            <Col className="inner-custom-pagination d-flex">
                                              <div className="d-inline">
                                                <SizePerPageDropdownStandalone
                                                  {...paginationProps}
                                                />
                                              </div>
                                              <div className="text-md-right ms-auto">
                                                <PaginationListStandalone
                                                  {...paginationProps}
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </React.Fragment>
                                      )}
                                    </ToolkitProvider>
                                  )}
                                </PaginationProvider>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </div>
                      </CardBody>
                    </Card>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
